﻿import Localizer from './wwwroot/js/Controllers/Localizer'
import LayoutDesignController from './wwwroot/js/Controllers/LayoutDesignController'
import VirtualScreenDesignController from './wwwroot/js/Controllers/VirtualScreenDesignController'
import FileUploadController from './wwwroot/js/Controllers/FileUploadController'
import BasicViewControllerWithCRUDDataSource from './wwwroot/js/Controllers/BasicViewControllerWithCRUDDataSource'
import ViewControllerWithCustomCRUDDataSource from './wwwroot/js/Controllers/ViewControllerWithCustomCRUDDataSource'
import TvsScreensBoxesConnectControllerWithCustomCRUDDataSource from './wwwroot/js/Controllers/TvsScreensBoxesConnectController'
import BoxesController from './wwwroot/js/Controllers/BoxesController'
import ContentEditorController from './wwwroot/js/Controllers/ConfigurationDesignController'
import ContentSelectionController from './wwwroot/js/Controllers/ContentSelectionController'
import ContentController from './wwwroot/js/Controllers/ContentController'
import ContentDetailController from './wwwroot/js/Controllers/ContentDetailController'
import RepeaterController from './wwwroot/js/Controllers/RepeaterController'
import SujetDesignController from './wwwroot/js/Controllers/SujetDesignController'
import BatchController from './wwwroot/js/Controllers/BatchController'
import BatchStateController from './wwwroot/js/Controllers/BatchStateController'
import UserController from './wwwroot/js/Controllers/UserController'


//////////////////
// WEBPACK FOOTER
// ./WebpackEntry.js
// module id = 367
// module chunks = 0